<template>
  <TopBar title="In which country did you study?" :step="step"/>
  <div class="step">
    <div class="multiselect-container" :class="{invalid: !countryStudyValid}">
      <Multiselect
        v-model="countryOfStudy"
        @close="checkValidityCountry"
        @input="checkValidityCountry"
        :options="countries"
        :searchable="true"
        placeholder="Please select the country in which you studied"
        ref="multiselect"
      />
      <p class="error-label">Incorrect or no answer submitted</p>
    </div>
    <h1>What year did you complete this qualification?</h1>
    <div class="form-row">
      <div class="wide">
        <div class="multiselect-container-bottom" :class="{invalid: !studyCompletedValid}">
        <Multiselect
          id="studyCompleted"
          @change="setYearComplete"
          @close="checkValidityStudy"
          @input="checkValidityStudy"
          :value="studyCompleted"
          :options="years"
          :searchable="true"
          placeholder="Year you received your qualification"
          ref="multiselect-year"
        />
        <p class="error-label">Incorrect or no answer submitted</p>
        </div>
      </div>
      <div class="thin">
        <button class="btn-check" :class="{ selected: notCompletedStudy }" @click="notCompleted">
          <div class="circle">
            <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4.2L3.66667 7L9 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div>I have not completed this qualification</div>
        </button>
      </div>
    </div>
  </div>
  <BottomBar :step="step" :percent="percent" :valid="valid"/>
</template>
<script>
import { mapState } from 'vuex'

import countries from './countries'
import Multiselect from '@vueform/multiselect'

import TopBar from '@/components/TopBar'
import BottomBar from '@/components/BottomBar'

export default {
  props: {
    step: {
      required: true
    }
  },
  components: {
    TopBar,
    BottomBar,
    Multiselect
  },
  computed: {
    years () {
      const year = new Date().getFullYear()
      const years = Array.from({ length: year - 1900 }, (value, index) => 1901 + index)
      years.reverse()
      return years
    },
    countryOfStudy: {
      get () { return this.$store.state.formData.countryOfStudy },
      set (value) { this.$store.commit('setFormData', { key: 'countryOfStudy', value }) }
    },
    ...mapState({
      studyCompleted: state => state.formData.studyCompleted,
      notCompletedStudy: state => state.formData.notCompletedStudy
    })
  },
  data () {
    return {
      valid: false,
      studyCompletedValid: true,
      countryStudyValid: true,
      countries: countries,
      percent: 60
    }
  },
  methods: {
    setYearComplete (value) {
      this.$store.commit('setFormData', { key: 'studyCompleted', value: value })
    },
    checkValidityStudy () {
      if (this.studyCompleted !== '' && this.studyCompleted !== null) {
        this.studyCompletedValid = true
      } else {
        this.studyCompletedValid = false
      }
    },
    checkValidityCountry () {
      if (this.countryOfStudy !== '' && this.countryOfStudy !== null) {
        this.countryStudyValid = true
      } else {
        this.countryStudyValid = false
      }
    },
    setFormData (value, key) {
      this.$store.commit('setFormData', { key, value })
    },
    notCompleted () {
      this.$store.commit('setFormData', { key: 'notCompletedStudy', value: !this.notCompletedStudy })
      this.$router.push('/step/7')
    }
  },
  watch: {
    studyCompleted: {
      immediate: true,
      handler (value) {
        if (!value || value.length === 0) {
          this.percent = 60
          this.valid = false
        } else {
          this.percent = 70
          this.valid = true
        }
      }
    }
  },
  mounted () {
    this.$refs.multiselect.$el.focus()
  }
}
</script>
<style lang="scss">
@import "./../assets/scss/mixins";

#ec-steps.step-6 {
  .step {
    max-width: 50.5rem;
    margin: 0 auto;
    padding-bottom: 6rem;

    h1 {
      margin-bottom: 2rem;
      display: none;
    }

    @include respond-above(lg) {
      padding-bottom: 1rem;

      h1 {
        display: block;
      }
    }
  }

  .multiselect-container-bottom {
    position: relative;
    width: 100%;

    &.invalid {
      .multiselect-search {
        border: 1px solid #EB0518;
        background-color: #FDEAEC;
      }
      .error-label {
        display: block;
      }
    }
  }

  .error-label {
    display: none;
    color: #EB0518;
    position: absolute;
    font-size: 12px;
    bottom: -22px;
    left: 26px;
    margin-bottom: 0;
  }

  .multiselect-container {
    margin-bottom: 2rem;
    position: relative;

    &.invalid {
      .multiselect-search {
        border: 1px solid #EB0518;
        background-color: #FDEAEC;
      }
      .error-label {
        display: block;
      }
    }
  }

  .multiselect-dropdown {
    margin-bottom: 0;

    @include respond-above(lg) {
      margin-bottom: 0;
      height: 17.5rem;
      max-height: 17.5rem;
    }
  }

  #studyCompleted {
    .multiselect-dropdown {
      height: 130px;
      max-height: 130px;
    }
  }

  .form-row {
    flex-direction: column;
    margin-right: 0;
    margin-left: 0;

    .wide {
      flex-basis: 100%;
      padding: 0 0 1rem;
    }

    .thin {
      flex-basis: 100%;
      // padding: 0 0 1rem;
    }

    @include respond-above(lg) {
      flex-direction: row;

      .wide {
        flex-basis: 150px;
        padding: 0.5rem 0;
        margin-right: 1rem;
      }

      .thin {
        flex-basis: auto;
        flex-grow: 0;
        flex-shrink: 1;
        padding: 0.5rem 0;
      }
    }

    .btn-check {
      margin: 0;
      padding: 0.5rem 0;
    }
  }
}
</style>
